module.exports = __webpack_public_path__ + "templates.dialog.promotion-term-d3ea17f4.html";